module.exports = __webpack_public_path__ + "static/media/land_geel.3f72158f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/land_geel.svg
// module id = 607
// module chunks = 0